import { appMethod as app } from '@utils/app';
import util from '@utils/util';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';

import OfficialPage from '../OfficialPage';
import { TopNav } from '@common/top-nav/TopNav';
import './CouponDetail.less';

export default class CouponDetail extends OfficialPage {
  state = {
    topNavBarData: {
      title: '优惠券',
      isDefault: 0
    },
    detailShow: false,
    status: 'receive', // receive、use 默认为receive，从优惠券列表进入的则为use
    couponId: '', // receive时为商家设置优惠券id，use时为用户领取优惠券id
    franchiseeId: '',
    couponDetail: {},
    receiveSuccess: 0, // 领取成功弹窗是否显示
    receiveCount: 0, // 已领取数量
    receiveLimitNum: 0, // 领取限制数量
    rechargeSuccess: 0, // 充值成功弹窗是否显示
    verifySuccess: false,
    verifyQrcodeUrl: '',
    verifyShow: false,
    verifyData: {
      success: false,
      qrcodeUrl: ''
    },
    recving: false, // 领取中
    recv_type: '', // 领取渠道
    coupon: {}
  }

  constructor(props) {
    super(props);
    document.title = '优惠券';
  }


  componentWillMount(options = getCurrentPageQueryParams()) {
    let that = this
    let status = options.status || 'receive' // receive、use
    let couponId = options.detail || '' // receive时为优惠券Id, use时为用户领取的优惠券Id
    let franchiseeId = options.franchisee || ''
    let recv_type = options.recv_type || '' // 优惠券来源
    that.setData({
      status: status,
      couponId: couponId,
      franchiseeId: franchiseeId,
      recv_type: recv_type
    })
    if (status == 'receive') {
      that.getCouponInfo()
    } else if (status == 'use') {
      that.getUserListCouponInfo()
    }
  }

  getCouponInfo = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetCouponInfo',
      data: {
        sub_app_id: that.data.franchiseeId,
        coupon_id: that.data.couponId
      },
      hideLoading: true,
      success: function(res) {
        that.setCouponData(res.data)
      }
    })
  }
  getUserListCouponInfo = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getUserListCouponInfo',
      data: {
        sub_app_id: that.data.franchiseeId,
        user_coupon_id: that.data.couponId,
        verify_log_order_by: 'desc'
      },
      hideLoading: true,
      success: function(res) {
        let coupon = res.data[0]
        if (!coupon) {
          that.setData({
            status: 'receive'
          })
          that.getCouponInfo()
          return
        }
        let verifyLogList =
          (coupon.form_data && coupon.form_data.verify_log) || []
        if (verifyLogList && verifyLogList.length !== 0) {
          verifyLogList.forEach(item => {
            item.add_time = util.formatTimeYMD(
              item.add_time,
              'YYYY/MM/DD hh:mm:ss'
            )
          })
        }
        that.setCouponData(coupon)
      }
    })
  }
  setCouponData = data => {
    let that = this
    let useCondition = ''
    let stampsUser = ''
    if (data.type == 0) {
      useCondition = '满' + data.condition + '，减' + data.value + '元'
    } else if (data.type == 1) {
      useCondition = '打' + data.value + '折'
    } else if (data.type == 2) {
      useCondition = '可抵扣' + data.value + '元'
    } else if (data.type == 3) {
      if (data.extra_condition == '') {
        useCondition = '直接兑换' + data.coupon_goods_info.title
      } else if (data.extra_condition.price) {
        useCondition =
          '消费满' +
          data.extra_condition.price +
          '元可兑换' +
          data.coupon_goods_info.title
      } else if (data.extra_condition.goods_id) {
        useCondition =
          '购买' +
          data.condition_goods_info.title +
          '可兑换' +
          data.coupon_goods_info.title
      }
    } else if (data.type == 4) {
      useCondition = '储值金可充值' + data.value + '元'
    } else if (data.type == 5) {
      useCondition = data.extra_condition
    } else if (data.type == 6) {
      useCondition = '可使用' + parseInt(data.value) + '次'
    }
    if (data.user_condition_list && data.user_condition_list.length > 0) {
      data.user_condition_list.forEach((res, i) => {
        if (i == data.user_condition_list.length - 1) {
          stampsUser = stampsUser + res
        } else {
          stampsUser = stampsUser + res + ','
        }
      })
    } else {
      if (data.user_condition == '0') {
        stampsUser = '所有用户'
      }
      if (data.user_condition == '1') {
        stampsUser = '所有会员'
      }
    }
    let newData = data
    newData['useCondition'] = useCondition
    newData['stampsUser'] = stampsUser
    that.setData({
      couponDetail: newData
    })
    that.setData({
      detailShow: true
    })
  }
  goToHomepage = () => {
    var homepageRouter = app.getHomepageRouter()
    app.turnToPage('/pages/' + homepageRouter + '/' + homepageRouter, 1)
  }
  formSubmit = event => {
    let that = this,
      formId = event.detail.formId
    if (this.data.recving) {
      return
    }
    this.setRecving(true)
    app.sendRequest({
      url: '/index.php?r=AppShop/RecvCoupon',
      data: {
        coupon_id: that.data.couponId,
        sub_app_id: that.data.franchiseeId,
        form_id: formId,
        recv_type: that.data.recv_type
      },
      hideLoading: true,
      success: function(res) {
        that.setData({
          receiveSuccess: 1,
          receiveCount: res.data.recv_count,
          receiveLimitNum: res.data.limit_num,
          'couponDetail.is_already_recv': res.data.is_already_recv
        })
        setTimeout(function() {
          that.hideReceiveToast()
        }, 3000)
      },
      complete: function() {
        that.setRecving(false)
      }
    })
  }
  setRecving = bool => {
    this.setData({
      recving: bool
    })
  }
  gotoTransferPage = () => {
    let url = '/eCommerce/pages/transferPage/transferPage'
    if (this.data.franchiseeId) {
      url += '?franchisee=' + this.data.franchiseeId
    }
    app.turnToPage(url, false)
  }
  gotoRecharge = event => {
    let that = this
    let userCouponId = event.currentTarget.dataset.id
    app.sendRequest({
      url: '/index.php?r=AppShop/useCoupon',
      data: {
        user_coupon_id: userCouponId
      },
      hideLoading: true,
      success: function(res) {
        that.setData({
          rechargeSuccess: 1,
          'couponDetail.status': 2
        })
        setTimeout(function() {
          that.hideRechargeToast()
        }, 3000)
      }
    })
  }
  hideReceiveToast = () => {
    this.setData({
      receiveSuccess: 0,
      receiveCount: 0,
      receiveLimitNum: 0
    })
  }
  hideRechargeToast = () => {
    this.setData({
      rechargeSuccess: 0
    })
  }
  onShareAppMessage = res => {
    var that = this
    var franchiseeId = that.data.franchiseeId
    var couponId = ''
    if (that.data.status == 'receive') {
      couponId = that.data.couponId
    } else if (that.data.status == 'use') {
      couponId = that.data.couponDetail.coupon_id
    }
    return {
      title: '速抢！限量优惠券，别说我不爱你~',
      path:
        '/pages/couponDetail/couponDetail?status=' +
        (that.data.status || 'receive') +
        '&detail=' +
        couponId +
        '&franchisee=' +
        franchiseeId,
      success: function(res) {},
      fail: function(res) {}
    }
  }
  showCouponVerify = () => {
    var qrcodeUrl =
      `${app.globalData.siteBaseUrl}` +
      `/index.php?r=AppShop/couponQrcode&app_id=${
        this.data.franchiseeId ? this.data.franchiseeId : app.globalData.appId
        }` +
      `&user_coupon_id=${this.data.couponId}`
    this.setData({
      detailShow: false,
      verifyShow: true,
      'verifyData.qrcodeUrl': qrcodeUrl
    })
    this.connectSocket()
  }
  hideCouponVerify = () => {
    this.setData({
      detailShow: true,
      verifyShow: false
    })
    clearInterval(this.timeInterval)
    this.socketOpen && app.closeSocket()
  }
  timeInterval = ''
  socketOpen = false
  connectSocket = () => {
    var that = this
    app.connectSocket({
      url: 'wss://ceshi.zhichiwangluo.com', //线下test
      header: {
        'content-type': 'application/json'
      },
      method: 'GET'
    })
    app.onSocketOpen(function(res) {
      that.socketOpen = true
      let data = {
        action: 'mark_client',
        user_token: app.globalData.userInfo.user_token,
        scenario_name: 'app_coupon_verify',
        session_key: app.globalData.sessionKey
      }
      app.sendSocketMessage({
        data: JSON.stringify(data)
      })
      that.timeInterval = setInterval(function() {
        let data = {
          action: 'heartbeat',
          user_token: app.globalData.userInfo.user_token,
          scenario_name: 'app_coupon_verify',
          session_key: app.globalData.sessionKey
        }
        app.sendSocketMessage({
          data: JSON.stringify(data)
        })
      }, 30000)
    })
    app.onSocketMessage(function(res) {
      let { couponDetail } = that.data
      let data = JSON.parse(res.data)
      if (data.action == 'push_to_client') {
        let msg = JSON.parse(data.msg)
        if (msg.type == 'app_coupon_verify' && msg.status == 0) {
          if (couponDetail.type != 6) {
            that.setData({
              'couponDetail.status': 2
            })
          } else {
            // 次数券
            let unVerfiyTimes = couponDetail.un_verify_times - 1
            let verifiedTimes = couponDetail.verified_times + 1
            that.setData({
              'couponDetail.un_verify_times': unVerfiyTimes,
              'couponDetail.verified_times': verifiedTimes
            })
            if (unVerfiyTimes == 0) {
              that.setData({
                'couponDetail.status': 2
              })
            }
          }
          that.setData({
            'verifyData.success': true
          })
          clearInterval(that.timeInterval)
          app.closeSocket()
        }
      }
    })
    app.onSocketClose(function(res) {
      that.socketOpen = false
      clearInterval(that.timeInterval)
      console.log('WebSocket 已关闭！')
    })
    app.onSocketError(function(res) {
      that.socketOpen = false
      console.log('WebSocket连接打开错误，请检查！')
    })
  }

  componentWillUnmount() {
    var that = this
    clearInterval(that.timeInterval)
    that.socketOpen && app.closeSocket()
  }

  turnToCouponGoodsList = event => {
    let couponId =
      this.data.status === 'receive'
        ? this.data.couponId
        : this.data.couponDetail.coupon_id
    let franchiseeId = this.data.franchiseeId
    let url =
      '/eCommerce/pages/couponGoodsListPage/couponGoodsListPage?detail=' +
      couponId
    if (franchiseeId) {
      url += '&franchisee=' + franchiseeId
    }
    app.turnToPage(url)
  }
  toggleVerificationDetail = () => {
    let { verificationDetailShow } = this.data
    let isShow = verificationDetailShow ? false : true
    let title = isShow ? '核销详情' : '优惠券'
    this.setData({
      detailShow: !isShow,
      verificationDetailShow: isShow,
      'topNavBarData.title': title
    })
  }

  render() {
    const {
      couponDetail,
      detailShow,
      status,
      coupon,
      receiveSuccess,
      receiveCount,
      receiveLimitNum,
      rechargeSuccess,
      verifyShow,
      verifyData,
      verificationDetailShow
    } = this.state
    return (
      <div className="official-page coupon-detail">
        <TopNav title="优惠券" />
        <div
          className="page"
          id="couponDetail"
          style={convertLineStyleData('background: ' + couponDetail.background)}
        >
          <div className={'coupon-detail-wrap ' + (detailShow ? 'show' : '')}>
            <div className="top-section">
              <img className="logo" src={couponDetail.logo} />
              <div className="name">{couponDetail.app_name}</div>
              <div
                className="ico-moon icon-share-new share"
                hidden={
                  (status == 'use' && couponDetail.in_show_list == 0) ||
                  (status == 'receive' &&
                    (couponDetail.enable_status == 0 ||
                      couponDetail.stock == 0 ||
                      couponDetail.in_show_list == 0))
                }
              >
                <button
                  className="share-btn" 
                  onClick={this.shareClickEvent}
                  // openType="share"
                ></button>
              </div>
              <div className="division-line">
                <div
                  className="left-circle"
                  style={convertLineStyleData('background: ' + couponDetail.background)}
                ></div>
                <div
                  className="right-circle"
                  style={convertLineStyleData('background: ' + couponDetail.background)}
                ></div>
              </div>
            </div>
            <div className="middle-section">
              <div
                className="title"
                style={convertLineStyleData(
                  status == 'use' && couponDetail.type != 4
                    ? 'padding-right:90rpx;'
                    : ''
                )}
              >
                {couponDetail.title}
              </div>
              <div className="sub-title">{couponDetail.sub_title}</div>
              {status == 'use' && couponDetail.type != 4 && (
                <div
                  className="ico-moon icon-qrcode-new qrcode"
                  onClick={this.showCouponVerify}
                ></div>
              )}
              <div
                // onSubmit={this.formSubmit}
                // reportSubmit={true}
                // data-coupon-id={coupon.id}
              >
                {status == 'receive' &&
                (couponDetail.enable_status == 0 ||
                  couponDetail.in_show_list == 0) &&
                couponDetail.exchangeable != 2 ? (
                  <div className="function-btn disabled">已下架</div>
                ) : status == 'receive' &&
                couponDetail.stock == 0 &&
                couponDetail.exchangeable != 2 ? (
                  <div className="function-btn disabled">已领完</div>
                ) : status == 'receive' &&
                couponDetail.is_already_recv == 1 &&
                couponDetail.exchangeable != 2 ? (
                  <div className="function-btn disabled">已领取</div>
                ) : status == 'receive' &&
                couponDetail.is_already_recv == 0 &&
                couponDetail.exchangeable != 2 ? (
                  <button
                    className="function-btn"
                    // formType="submit"
                    // type="submit"
                    onClick={this.formSubmit}
                    data-coupon-id={coupon.id}
                    style={convertLineStyleData('background-color:' + couponDetail.button_color)}
                  >
                    立即领取
                  </button>
                ) : status == 'use' && couponDetail.status == 2 ? (
                  <div className="function-btn disabled">已使用</div>
                ) : status == 'use' && couponDetail.status == 3 ? (
                  <div className="function-btn disabled">已失效</div>
                ) : status == 'use' && couponDetail.status == 4 ? (
                  <div className="function-btn disabled">未生效</div>
                ) : status == 'use' && couponDetail.type == 3 ? (
                  <div></div>
                ) : status == 'use' && couponDetail.type == 4 ? (
                  <div
                    className="function-btn"
                    onClick={this.gotoRecharge}
                    data-id={couponDetail.id}
                    style={convertLineStyleData('background-color:' + couponDetail.button_color)}
                  >
                    立即充值
                  </div>
                ) : (
                  status == 'use' && couponDetail.type == 5 && <div></div>
                )}
              </div>
              <div className="detail-item condition">
                <div className="item-name">使用条件：</div>
                <div className="item-content">
                  {couponDetail.useCondition}
                </div>
              </div>
              <div className="detail-item time">
                <div className="item-name">可用时间：</div>
                <div className="item-content">
                  <div className="date-duration">
                    {couponDetail.expire == '-1'
                      ? couponDetail.start_use_date +
                      '至' +
                      couponDetail.end_use_date
                      : couponDetail.expire == '0'
                        ? '领取当天生效,有效期1天'
                        : '领取' +
                        (couponDetail.react > 0
                          ? couponDetail.react + '天后'
                          : '当天') +
                        '生效，有效期' +
                        couponDetail.expire +
                        '天'}
                  </div>
                  <div className="other-case">
                    {(couponDetail.exclude_holiday == 1 ? '除法定节假日' : '') +
                    ' ' +
                    (couponDetail.exclude_weekend == 1 ? '周一至周五' : '')}
                  </div>
                  <div className="time-duration">
                    {couponDetail.start_use_time +
                    '-' +
                    couponDetail.end_use_time}
                  </div>
                </div>
              </div>
            </div>
            {couponDetail.type == 6 && status == 'use' && (
              <div
                className="middle-section"
                onClick={this.toggleVerificationDetail}
              >
                <div className="detail-item verify">
                  <div className="item-right">
                    <span className="item-name">核销详情</span>
                    <div className="item-content">
                      <span>{'已核销：' + couponDetail.verified_times}</span>
                      <span>
                        {'未核销：' +
                        (couponDetail.verify_times -
                          couponDetail.verified_times)}
                      </span>
                    </div>
                  </div>
                  <div className="ico-moon icon-rightarrow"></div>
                </div>
              </div>
            )}
            <div className="bottom-section">
              {couponDetail.extra_goods && couponDetail.extra_goods != 'null' && (
                <div
                  className="detail-item couponGoods"
                  onClick={this.turnToCouponGoodsList}
                >
                  <div className="item-name">部分可用商品</div>
                  <div className="item-right">
                    <span>查看</span>
                    <label className="ico-moon icon-rightarrow"></label>
                  </div>
                </div>
              )}
              {couponDetail.address != '' && (
                <div className="detail-item address">
                  <div className="item-name">店铺地址：</div>
                  <div className="item-content">{couponDetail.address}</div>
                </div>
              )}
              {couponDetail.stampsUser != '' && (
                <div className="detail-item detail-item-user">
                  <div className="item-name">可领取用户：</div>
                  <div className="item-content">
                    {couponDetail.stampsUser}
                  </div>
                </div>
              )}
              {couponDetail.phone != '' && (
                <div className="detail-item phone">
                  <div className="item-name">联系电话：</div>
                  <div className="item-content">{couponDetail.phone}</div>
                </div>
              )}
              <div className="goto-homepage" onClick={this.goToHomepage}>
                <div className="goto-homepage-text">返回首页</div>
                <div className="ico-moon icon-rightarrow"></div>
              </div>
            </div>
          </div>
          <div
            className={'zc-toast-bg ' + (receiveSuccess == 1 ? 'show' : '')}
            onClick={this.hideReceiveToast}
          >
            <div className="zc-toast receive-success">
              <span className="icon" type="success" size="20"></span>
              <div className="title">领取成功!</div>
              <div className="content">
                {'已领' + receiveCount + '张，限领' + receiveLimitNum + '张'}
              </div>
            </div>
          </div>
          <div
            className={'zc-toast-bg ' + (rechargeSuccess == 1 ? 'show' : '')}
            onClick={this.hideToast}
          >
            <div className="zc-toast recharge-success">
              <span className="icon" type="success" size="20"></span>
              <div className="title">充值成功!</div>
              <div className="content">请到储值金中查看</div>
            </div>
          </div>
          <div className={'coupon-verify-wrap ' + (verifyShow ? 'show' : '')}>
            <div className="top-section">
              <div
                className="cancel"
                onClick={this.hideCouponVerify}
                hidden={verifyData.success}
              >
                取消
              </div>
              <div className="name">{couponDetail.app_name}</div>
              <div className="title">{couponDetail.title}</div>
            </div>
            <div className="division-line">
              <div
                className="left-circle"
                style={convertLineStyleData('background: ' + couponDetail.background)}
              ></div>
              <div
                className="right-circle"
                style={convertLineStyleData('background: ' + couponDetail.background)}
              ></div>
            </div>
            <div className="bottom-section">
              {!verifyData.success ? (
                <div className="verify-block">
                  <img className="qrcode" src={verifyData.qrcodeUrl} />
                  <div className="code">
                    {'核销码：' + couponDetail.verify_code}
                  </div>
                  <div className="tip">提示：请提示商家扫码核销</div>
                </div>
                ) : (
                verifyData.success && (
                <div className="success-block">
                  <div className="success-tip">
                    <span
                      className="success-tip-icon"
                      type="success"
                      size="20"
                    ></span>
                    <span className="success-tip-text">核销成功!</span>
                  </div>
                  <div className="back-tip" onClick={this.hideCouponVerify}>
                  >>>返回
                  </div>
                </div>
                )
                )}
            </div>
          </div>
          {/*  核销详情  */}
          <div
          className={
            'coupon-cerification-detail ' +
            (verificationDetailShow ? 'show' : '')
          }
          >
            <div className="detail-title">
              <span className="detail-num num">序号</span>
              <span className="detail-time">核销时间</span>
            </div>
            {couponDetail.form_data && couponDetail.form_data.verify_log &&
            couponDetail.form_data.verify_log.length !== 0 ? (
              <div className="detail-list">
                {couponDetail.form_data.verify_log.map((item, index) => {
                  return (
                    <div className="detail-item" key={index}>
                      <span className="item-num num">{index + 1}</span>
                      <span className="item-time">{item.add_time}</span>
                    </div>
                  )
                })}
              </div>
            ) : (
              <div className="detail-nodata">- 暂无数据 -</div>
            )}
            <div
              className="detail-back-btn"
              onClick={this.toggleVerificationDetail}
            >
            返回
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/coupon-detail/CouponDetail.jsx